// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","sortableList":"_1cqzIhd91fOTlpBl2_hfUv","sortableHelper":"_1QyHQvf0qd7cKRedKc_1ni"};